import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useShallow } from "zustand/react/shallow";

import Notify from '~/components/Notify';
import { notificationStore } from '~/stores/notification';

import "./style.less";
import { classNames } from "~/utils/utils";

export interface IContent{
	className?: string;
	mainContent?: ReactNode;
	rightContent?: ReactNode;
	centerContent?: ReactNode;
}

export default function ContentLayout({
	className = "",
	mainContent = null,
	rightContent = null,
	centerContent = null,
} : IContent) {
	const location = useLocation();

	const hideRightContent = ['/', '/login', '/register', '/verify', '/forgotPassword', '/resetPassword'].includes(location.pathname);

	const { notification, clearNotification } = notificationStore(useShallow(notificationState => ({
		notification: notificationState.notification,
		clearNotification: notificationState.clearNotification,
	})));

	useEffect(() => {
		clearNotification();
	}, []);

	useEffect(() => {
		try {
			// Kontrola, zda už reklama nebyla pushnuta, aby se předešlo chybám
			(window.adsbygoogle = window.adsbygoogle || []).push({});
		} catch (err) {
			//console.error("AdSense error:", err);
		}
	}, []);


	return <div className={classNames(["contentLayout", hideRightContent ? "contentLayout--noRight" : "", className])}>
		{ centerContent
			? <div className="centerContent">
				{centerContent}
			</div>
			: <>
				<div className="mainContent">
					{mainContent}
				</div>
				{!hideRightContent && (
					<div className="rightContent">
						{rightContent}
						<div className="adsBanner">
							<ins className="adsbygoogle"
								style= {{ display: 'block' }}
								data-ad-client="ca-pub-4612020243596066"
								data-ad-slot="8672278343"
								data-ad-format="auto"
								data-full-width-responsive="true"></ins>
						</div>
					</div>
				)}
			</>
		}
		<Notify open={ notification.visible } onClose={() => clearNotification()} type={ notification.color }>
			<p style={{ margin: "0" }}>{ notification.msg }</p>
		</Notify>
	</div>;
}
